import { LandPlot, ScrollText, Map, Ruler, Network, Radar, Plane } from "lucide-react";

// Text (title, tagline, intro, includes, blocks, refs, galleryTitle, gallery captions)
// lives in i18n under services.items.<slug>. Here we keep only language-agnostic data.
export const SERVICES = [
  {
    slug: "katastarski-premjer",
    icon: LandPlot,
    image: "https://images.unsplash.com/photo-1766830110938-0ea8a6d78ecb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "legalizacija",
    icon: ScrollText,
    image: "https://images.unsplash.com/photo-1601658797866-7ae55d05a817?fm=jpg&q=85&w=1600&auto=format&fit=crop",
    external: "/legalizacija",
  },
  {
    slug: "kartografija",
    icon: Map,
    image: "/img/plan-grada-pucisca.webp",
    gallery: [
      "/img/plan-grada-pucisca.webp",
      "/img/primosten-brosura.webp",
      "/img/vrboska-ortofoto.webp",
      "/img/biskupija-karta.webp",
      "/img/primosten-pano.webp",
    ],
  },
  {
    slug: "inzenjerska-geodezija",
    icon: Ruler,
    image: "/img/ig-gnss.webp",
    gallery: [
      "/img/ig-gnss.webp",
      "/img/ig-vijadukt.webp",
      "/img/ig-kamenolom.webp",
      "/img/ig-zemljani.webp",
      "/img/ig-cesta.webp",
    ],
  },
  {
    slug: "lidar",
    icon: Radar,
    image: "/img/lidar-visina.webp",
    gallery: [
      "/img/lidar-visina.webp",
      "/img/lidar-cesta.webp",
      "/img/lidar-kolonada.webp",
      "/img/lidar-kuca.webp",
      "/img/lidar-oblak.webp",
    ],
  },
  {
    slug: "aerofotogrametrija",
    icon: Plane,
    image: "/img/aero-obala.webp",
    gallery: [
      "/img/aero-obala.webp",
      "/img/aero-cesta.webp",
      "/img/aero-3d.webp",
      "/img/aero-detalj.webp",
      "/img/aero-dtm.webp",
    ],
  },
  {
    slug: "gis-smartcity",
    icon: Network,
    image: "/img/gis-dashboard.webp",
    gallery: [
      "/img/gis-dashboard.webp",
      "/img/gis-preglednik.webp",
      "/img/gis-infra.webp",
      "/img/gis-planovi.webp",
      "/img/gis-prijava.webp",
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
